import React from 'react';
import { Handshake, TrendingUp, Phone, MessageCircle } from 'lucide-react';
import { companyInfo } from '../mockData';

export const WholesaleCTASection = () => {
  return (
    <section className="py-16 lg:py-24 bg-gradient-to-br from-blue-900 to-blue-800 text-white relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-cyan-500 rounded-full mix-blend-multiply filter blur-3xl opacity-20"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-blue-600 rounded-full mix-blend-multiply filter blur-3xl opacity-20"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-6">
            <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full">
              <Handshake size={20} />
              <span className="font-semibold">Partnership Opportunities</span>
            </div>
            
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight">
              Looking for a Reliable Printer Consumables Supplier?
            </h2>
            
            <p className="text-lg text-blue-100 leading-relaxed">
              Partner with FillTech Technologies and Solutions for genuine products, competitive pricing, dependable support, and long-term business relationships.
            </p>

            {/* Benefits List */}
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <div className="w-2 h-2 bg-cyan-400 rounded-full"></div>
                <span className="text-blue-100">Exclusive wholesale pricing for dealers</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-2 h-2 bg-cyan-400 rounded-full"></div>
                <span className="text-blue-100">Priority support and fast order processing</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-2 h-2 bg-cyan-400 rounded-full"></div>
                <span className="text-blue-100">Flexible payment terms for bulk orders</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-2 h-2 bg-cyan-400 rounded-full"></div>
                <span className="text-blue-100">Marketing support for our partners</span>
              </div>
            </div>
          </div>

          {/* Right Content - CTA Cards */}
          <div className="space-y-6">
            {/* Dealer Card */}
            <div className="bg-white text-gray-900 rounded-2xl p-8 shadow-2xl transform hover:scale-105 transition-all duration-300">
              <Handshake className="text-blue-900 mb-4" size={40} />
              <h3 className="text-2xl font-bold mb-3">Become a Dealer</h3>
              <p className="text-gray-600 mb-6">
                Join our network of successful dealers across Kerala and grow your business with us.
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <a
                  href="tel:9387294448"
                  className="flex items-center justify-center gap-2 bg-blue-900 text-white px-6 py-3 rounded-lg hover:bg-blue-800 transition-colors duration-200 font-semibold"
                >
                  <Phone size={18} />
                  Call Now
                </a>
                <a
                  href="https://wa.me/919387294448?text=Hi, I'm interested in becoming a dealer"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center gap-2 bg-green-600 text-white px-6 py-3 rounded-lg hover:bg-green-700 transition-colors duration-200 font-semibold"
                >
                  <MessageCircle size={18} />
                  WhatsApp
                </a>
              </div>
            </div>

            {/* Wholesale Card */}
            <div className="bg-white text-gray-900 rounded-2xl p-8 shadow-2xl transform hover:scale-105 transition-all duration-300">
              <TrendingUp className="text-blue-900 mb-4" size={40} />
              <h3 className="text-2xl font-bold mb-3">Wholesale Pricing</h3>
              <p className="text-gray-600 mb-6">
                Get the best wholesale rates in Kerala for bulk orders and regular supply.
              </p>
              <button
                onClick={() => {
                  const element = document.getElementById('contact');
                  if (element) element.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full bg-blue-900 text-white px-6 py-3 rounded-lg hover:bg-blue-800 transition-colors duration-200 font-semibold"
              >
                Request Pricing
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
